import { useAxios } from '../../Helpers/AxiosHelper';
import { useForm } from 'react-hook-form';
import { useToast } from '../../Helpers/ToastHelper';
import { useTranslation } from 'react-i18next';
import { classNames } from 'primereact/utils';
import { FloatLabel, InputText, SCButton, SubmitHandler } from "../../Common/Imports"
import { ApiResponse, Brands_EXT } from '../../Models/Classes';
import { ValidateEmail } from '../../Common/Utility/ValidateEmail';
interface BrandNewProps {
    stakeholderId: number;
    OnSave?: () => void;
}

const BrandNew: React.FC<BrandNewProps> = ({ stakeholderId, OnSave }) => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<Brands_EXT>();
    const AxiosHelper = useAxios();

    const onSubmit: SubmitHandler<Brands_EXT> = async (data: Brands_EXT) => {
        data.idStakeholder = stakeholderId;
        try {
            await AxiosHelper.post<ApiResponse<Brands_EXT>>(`Brand/CreateBrand`, data);
            showToast('success', 'Success', t("Common.Toasts.New.Success"));
            if (OnSave) {
                OnSave();
            }
        } catch (error: unknown) {
            console.log(error);
            showToast('error', 'Error', t("Common.Toasts.New.Error"));
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <div className="row mb-3 mt-3">
                <div className="col-md-6 mb-4">
                    <FloatLabel>
                        <label htmlFor="Name">{t("Brand.New.Name")}</label>
                        <InputText
                            id="Name"
                            {
                            ...register(
                                'name',
                                {
                                    required: t("Brand.New.Name") + " " + t("Auth.Register.Form.Required")
                                })
                            }
                            className={
                                classNames({ 'p-invalid': errors.name })
                            } />
                    </FloatLabel>
                    {
                        errors.name &&
                        <small className="p-error">
                            {errors.name.message}
                        </small>
                    }
                </div>
                <div className="col-md-6 mb-4">
                    <FloatLabel>
                        <label htmlFor="ProviderBrand">{t("Brand.New.ProviderBrand")}</label>
                        <InputText
                            id="ProviderBrand"
                            {
                            ...register('providerBrand')
                            }
                            className={
                                classNames({ 'p-invalid': errors.providerBrand })
                            } />
                    </FloatLabel>
                    {
                        errors.providerBrand &&
                        <small className="p-error">
                            {errors.providerBrand.message}
                        </small>
                    }
                </div>
                <div className="col-md-6 mb-4">
                    <FloatLabel>
                        <label htmlFor="Email">{t("Brand.New.Email")}</label>
                        <InputText
                            id="Email"
                            {
                            ...register(
                                'emails',
                                {
                                    required: t("Brand.New.Email") + " " + t("Auth.Register.Form.Required"),
                                    validate: (value) => value && ValidateEmail(value) || t("Brand.New.Email") + " " + t("Common.Form.Invalid")
                                })
                            }
                            className={
                                classNames({ 'p-invalid': errors.emails })
                            } />
                    </FloatLabel>
                    {
                        errors.emails &&
                        <small className="p-error">
                            {errors.emails.message}
                        </small>
                    }
                </div>
                <div className="col-md-6 mb-4">
                    <FloatLabel>
                        <label htmlFor="Phone">{t("Brand.New.Phone")}</label>
                        <InputText
                            id="Phone"
                            {
                            ...register(
                                'phone',
                                {
                                    required: t("Brand.New.Phone") + " " + t("Auth.Register.Form.Required")
                                })
                            }
                            className={
                                classNames({ 'p-invalid': errors.phone })
                            } />
                    </FloatLabel>
                    {
                        errors.phone &&
                        <small className="p-error">
                            {errors.phone.message}
                        </small>
                    }
                </div>
                <div className="col-md-12 mb-4">
                    <FloatLabel>
                        <label htmlFor="Logo">{t("Brand.New.Logo")}</label>
                        <InputText
                            id="Logo"
                            {
                            ...register('logo')
                            }
                            className={
                                classNames({ 'p-invalid': errors.logo })
                            } />
                    </FloatLabel>
                    {
                        errors.logo &&
                        <small className="p-error">
                            {errors.logo.message}
                        </small>
                    }
                </div>
                <div className="row">
                    <div className="col">
                        <SCButton Type="submit" Label={t("Common.Buttons.Save")} Name="Save" />
                    </div>
                </div>
            </div>
        </form>
    );
};

export default BrandNew;
